import type { CaseDetail } from '../portfolio';

const plusKeshiponCase: CaseDetail = {
  id: 'plus-keshipon',
  project: 'PLUS ケシポン 大きな文字用',
  client: 'プラス株式会社',
  year: 'Archive',
  category: 'Retail Tool / Promotion',
  role: 'Retail Tool Design / Promotion / POP',
  issue: '個人情報保護スタンプの大きな文字用市場が、認知されにくく、必要性が伝わっていなかった。',
  challenge: '「大きな文字の宛名」など、大きな文字の個人情報をしっかり隠せる必要性を、店頭でわかりやすく伝えること。',
  insight: '「大きな文字用ケシポン」——宛名など大きな文字の個人情報をしっかり隠すことの安心感が、購買の決め手になる。',
  strategy: '「大きな文字用ケシポン販促企画」として、店頭資材を通じて大きな文字でもしっかり消せる安心感を訴求。',
  experience: '店頭POP、立体ボード、プロモーション資材を通じて、個人情報保護の重要性と商品価値を伝える。',
  output: 'Retail Tool / POP / Promotion / Store Display',
  impact: '大きな文字用市場への訴求と、個人情報保護意識の啓発を実現。',
  images: [
    {
      src: '/assets/migrated/fb4c420cb8b7bdaae9b9.webp',
      caption: '単品カタログ デザインB案・C案 表紙面＋中面 — ローラーケシポン 大きな文字用 新発売！',
    },
    {
      src: '/assets/migrated/9b757f82c30c15eaf58c.webp',
      caption: 'コアコンセプト「親近感を売場で想起！」＋ 単品カタログ デザインA案 表紙面＋中面',
    },
    {
      src: '/assets/migrated/30de1abf16652397e415.webp',
      caption: '大きな文字用ケシポン 什器DP＆定番汎用 店頭POP案 — アテンション印面見本POP・カートリッジ交換POP・定番用アテンションPOP',
    },
    {
      src: '/assets/migrated/921e83306e3051c75729.webp',
      caption: '提案書表紙＋コミュニケーションプラン＋ツール訴求方向性＋個人情報漏えい媒体経路調査',
    },
    {
      src: '/assets/migrated/6b0c82f049737a6d87b5.webp',
      caption: 'ケシポン店頭資材 ツール展開図 A案＋B案 — 機能紹介・什器構成',
    },
    {
      src: '/assets/migrated/d9b62dee8e9f6473e8a4.webp',
      caption: '店頭什器実写写真 — ケシポン什器ディスプレイ＆カラフル商品陳列',
    },
    {
      src: '/assets/migrated/bbe1eeadd7a3d5d82c6e.webp',
      caption: '店頭什器実写写真 — ケシポン什器展示・ラインナップ展開',
    },
    {
      src: '/assets/migrated/4521f5ddab9eed872b0e.webp',
      caption: '提案書表紙 — プラス株式会社 御中 大きな文字用ケシポン 販促企画 店頭資材のご提案',
    },
    {
      src: '/assets/migrated/a2e6b92c8dd53d2bbfbe.webp',
      caption: 'PLUS ケシポン 大きな文字用 — ブランドビジュアル・店頭展開',
      large: true,
    },
  ],
};

export default plusKeshiponCase;